import DOMPurify from 'dompurify';

const setRelNoopener = (node: Element): void => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
};

/**
 * リッチテキストエディタ由来ではない汎用コンテンツ向け。オプションなしの DOMPurify デフォルト許可リストのみを使う。
 * フックは DOMPurify のシングルトンに積まれるため、他モジュールの sanitize に漏れないよう毎回外す。
 *
 * @deprecated utilではなく各機能ごとに整理中なのでこの関数は新規で利用しないこと
 */
export function sanitizeHtml(content: string): string {
  DOMPurify.addHook('afterSanitizeAttributes', setRelNoopener);
  try {
    return DOMPurify.sanitize(content);
  } finally {
    DOMPurify.removeHook('afterSanitizeAttributes', setRelNoopener);
  }
}
